import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddCarBrandDictionaryItemComponent } from 'src/app/shared/components/add-car-brand-dictionary-item/add-car-brand-dictionary-item.component';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { DictionaryDataItem } from 'src/app/shared/model/DictionaryDataItem';
import { CarDictionaryService } from 'src/app/shared/services/car-dictionary.service';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';


  
@Component({
  selector: 'car-brand-combo-select-ctrl',
  templateUrl: './car-brand-combo-select.component.html',
  styleUrls: ['./car-brand-combo-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CarBrandComboSelectComponent,
    multi: true
  }]
})
export class CarBrandComboSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, 
    private carDictionaryService: CarDictionaryService,
    private customDialogService:CustomDialogService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  
  @ViewChild("carBrandDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() allowDefineNew = true;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false, readonly:false};

  valuesList$: Observable<DictionaryDataItem[]>;
  term$ = new BehaviorSubject<string>('');

  textField  = 'value';
  valueField  = 'value';
 
  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {

     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
    this.valuesList$ = this.term$.pipe(
      AutoComplete.autocomplete(500, (term => this.carDictionaryService.getCarBrands(term))));
    this.filterChange(this.control.value);
  }

  onChange(value: any) {
    this.valueChangeEvent.emit(value);
  }

  public filterChange(filter: any): void {
      this.term$.next(filter);
      this.control.markAsTouched();
  }

  defineNewItem(){
    
    const dialogSettings: CustomDialogSettings = {
      content: AddCarBrandDictionaryItemComponent,
      appendTo: this.containerRef,
      maxWidth: '60vw',
      maxHeight: '60vh',
      dialogInputs: {
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          const newBrand = r['newBrand'];
          if(newBrand){
            this.filterChange(newBrand);
            this.control.setValue(newBrand);
          }
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }


  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    if(obj) {
      this.filterChange(obj);
    }
   
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}


